import type { TamSpendType } from "../../types/workspace";

type SpendCategoryWeight = { id: string; weight: number };

export const toCustomSpendCategory = (
  spendCategoryWeights: SpendCategoryWeight[] | undefined,
  spendType: TamSpendType | null | undefined
) =>
  spendCategoryWeights?.length
    ? {
        name: "",
        categories: spendCategoryWeights,
        ...(spendType === "AI" ? { spendType } : {}),
      }
    : undefined;
